import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import loginImage from "../assets/login.jpg";
import { useAuth } from "../contexts/AuthContext";
import { API_BASE_URL } from "../config/api";

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(""); // ✅ nom cohérent avec le champ
  const navigate = useNavigate();
const { login } = useAuth();
  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }), // ✅ correspond à ce que ton backend attend
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('tenant_id', data.user.tenant_id);
        login(data.user);
        navigate('/dashboard');
      } else {
        alert(data.message || 'Erreur de connexion');
      }
    } catch (error) {
      console.error('Erreur de connexion :', error);
      alert('Erreur serveur');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
const handleForgotPassword = () => {
  navigate("/mot-de-passe-oublie");
};

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="image-wrapper">
          <img src={loginImage} alt="Login" className="login-image" />
        </div>
        <div className="overlay-text">
          <h2>Espace Administrateur</h2>
          <p>
            Gérez vos prestations, vos locations et vos utilisateurs depuis
            votre espace administrateur.
          </p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-box">
          <h1 className="logo">WaaGo</h1>
          <h2>Connexion</h2>
          <p className="subtitle">
            Entrez votre adresse e-mail ou numéro de téléphone pour vous
            connecter.
          </p>

          <form className="login-form" onSubmit={handleLogin}>
            <label>Email ou téléphone</label>
            <input
              type="text"
              placeholder="exemple@mail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)} // ✅ correction ici
            />

            <label>Mot de passe</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="eye-button"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <button type="submit" className="btn-connect">
              Se connecter
            </button>

            <div className="forgot-link">
             
                <button type="button" className="link-button" onClick={handleForgotPassword}>
    Mot de passe oublié ?
  </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
